import { useMutation } from '@tanstack/react-query';

import { env } from '@/constants/env';
import { MutationConfig } from '@/lib/react-query';
import { api, extractData } from '@/lib/treaty';

import type {
  TYPE_DESIRED_COLOR_OPTIONS,
  TYPE_DESIRED_STYLE_OPTIONS,
  TYPE_MATERIAL_OPTIONS,
  TYPE_ROOM_MODE_OPTIONS,
  TYPE_ROOM_TYPE_OPTIONS,
} from '../constants/style-settings';

type RenderImageOptions = {
  mutationConfig?: MutationConfig<typeof renderImage>;
};

type RenderImageType = {
  image: File;
  roomtype: TYPE_ROOM_TYPE_OPTIONS;
  style: TYPE_DESIRED_STYLE_OPTIONS;
  colors?: TYPE_DESIRED_COLOR_OPTIONS[];
  materials?: TYPE_MATERIAL_OPTIONS[];
  mode: TYPE_ROOM_MODE_OPTIONS;
};

const renderImage = async ({
  image,
  roomtype,
  style,
  colors = [],
  materials = [],
  mode = 'changeStyle',
}: RenderImageType) => {
  return extractData(
    api['image-rendering'].post({
      image,
      roomtype,
      style,
      colors: colors.join(','),
      materials: materials.join(','),
      mode,
    })
  );
};

export const getRenderingImage = (taskId: string) => {
  return fetch(`${env.API_URL}/image-rendering/result/${taskId}`, {
    credentials: 'include',
  });
};

export const useRenderImage = ({ mutationConfig }: RenderImageOptions = {}) => {
  return useMutation({
    ...mutationConfig,
    mutationFn: renderImage,
  });
};
